/*
 * The reads a rep's act on the reply agent's work changes, in one place that imports none of the
 * app's modules, so the drafting switch, the agent's item and the inbox's list can all name them
 * without an import cycle (the drafting switch is part of the agent's detail schema).
 */
import type { QueryClient } from "@tanstack/react-query";

/**
 * The master inbox's list narrowed by a reply agent state (step 9), under the inbox's own key so an
 * inbox write (Done, Snooze) refreshes it too.
 */
export const agentListKey = (workspaceId: string) =>
  ["inbox-v2", workspaceId, "agent-list"] as const;

/**
 * After a rep acts on the agent's work (an approve, an answer, Draft again): the rows' states, and
 * the list narrowed by an agent state, which the act can move a row out of.
 */
export function refreshAgentReads(cache: QueryClient, workspaceId: string) {
  return Promise.all([
    cache.invalidateQueries({ queryKey: ["agent", workspaceId] }),
    cache.invalidateQueries({ queryKey: agentListKey(workspaceId) }),
  ]);
}
